<template>
  <v-dialog v-model="dialog_open" max-width="500">
    <v-card>
      <v-card-text style="background-color: #fff">
        <v-row class="pa-0 ma-0">
          <v-col cols="12">
            <v-img
              style="margin-left: auto; margin-right: auto"
              width="110px"
              height="110px"
              :src="require('@/assets/icon/Group 427323896.png')"
            ></v-img>
          </v-col>
          <v-col cols="12">
            <span
              class="ml-3 font-weight-bold font-24 text-000000 font-sarabun d-flex justify-center"
              style="color: #ff8082"
            >
              ส่งคืนแก้ไขยา
            </span>
          </v-col>
          <v-col cols="12">
            <span
              class="ml-3 font-weight-bold font-18 text-000000 font-sarabun d-flex justify-center"
              style="color: #979797"
            >
              โปรดระบุหมายเหตุ
            </span>
          </v-col>
          <v-col cols="12">
            <v-textarea
              hide-details="auto"
              solo
              dense
              v-model="sendEdit"
            ></v-textarea>
          </v-col>
          <v-col cols="12" sm="6">
            <v-btn
              color="#336AB4"
              dark
              outlined
              width="100%"
              height="48px"
              @click="close"
            >
              ยกเลิก
            </v-btn>
          </v-col>
          <v-col cols="12" sm="6">
            <v-btn
              color="#336AB4"
              dark
              width="100%"
              height="48px"
              @click="
                dialog_add = false;
                confirmEdit();
              "
            >
              ยืนยัน
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import Swal from "sweetalert2";
export default {
  data: () => ({
    dialog_open: false,
    sendEdit: "",
    time_slot_dentist_id: "",
  }),
  computed: {
    ...mapState(["appointmentDetail"]),
  },
  methods: {
    openDialog(item) {
      console.log("appointment", item);
      this.dialog_open = true;
    },
    close() {
      this.dialog_open = false;
      this.$emit("close");
    },
    async confirmEdit() {
      try {
        let body = {
          appointment_id: this.appointmentDetail.appointment_id,
          status_drug: "return",
          note: this.sendEdit,
          pharmacist_id: sessionStorage.account_id,
          pharmacist_name: sessionStorage.accountName,
        };
        await this.axios
          .put(`${process.env.VUE_APP_BACKEND_URL}/v1/drug-status`, body)
          .then(async (res) => {
            await this.$store.dispatch("actionLog", {
              action: "update drug status",
              action_by: sessionStorage.account_id,
              path: `/drug/update-status`,
              params: {
                time_slot_dentist_id: this.time_slot_dentist_id
              },
              body: {
                status: "2",
                note: this.sendEdit,
              }
            });
            const { data: { result } = {} } = res
            if (result === "success") {
              this.dialog_open = false;
              Swal.fire({
                position: "center",
                icon: "success",
                title: "ส่งคืนแก้ไขยาสำเร็จ",
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {
                this.$emit("close");
              });
              
            }
          });
      } catch (error) {
        console.error();
        Swal.fire({
          position: "center",
          icon: "error",
          title: "ส่งคืนแก้ไขยาไม่สำเร็จ",
          showConfirmButton: false,
          timer: 1500,
        });
      }
      this.sendEdit = "";
    },
  },
};
</script>

<style></style>
